// Search Trigger -- opens / closes the search popup. Ported from
// orion-v3.0's src/js/includes/search.js and rewritten from jQuery
// to vanilla JS.
//
// Open  : click on .search__trigger / .js-search__trigger
//         Toggles body.navbar--show-search; the popup wrapper
//         transitions in via opacity / visibility (CSS).
// Close : click on .search__backdrop / .search__close /
//         .icon-search-close, or ESC.
//
// On open, the input is cleared, the (predictive) results
// container is hidden, the Discovery initial state is shown
// (tier_3 only), and focus is moved to the input after the
// CSS transition completes.

(function () {
  const body = document.body;

  function closePopup() {
    body.classList.remove('navbar--show-search', 'navbar--show-megamenu');
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.search__trigger, .js-search__trigger');
    if (!trigger) return;
    e.preventDefault();

    const ps = document.querySelector('predictive-search');
    const searchType = ps ? ps.getAttribute('data-search-type') : null;

    const results = document.querySelector('#search-results');
    if (results) results.hidden = true;

    if (searchType !== 'tier_1' && searchType !== 'tier_2') {
      const initial = document.querySelector('.search__initial');
      if (initial) {
        initial.hidden = false;
        initial.style.opacity = '1';
        initial.style.display = '';
      }
    }

    const input = document.querySelector('.search .search__bar input');
    if (input) input.value = '';

    body.classList.remove('navbar--show-mobile-menu', 'navbar--show-megamenu');
    document.querySelectorAll('[data-megamenu].is-active').forEach((el) => {
      el.classList.remove('is-active');
      el.dispatchEvent(new CustomEvent('megamenu:closed'));
    });
    document.querySelectorAll('[data-trigger].active').forEach((t) => t.classList.remove('active'));
    body.classList.toggle('navbar--show-search');

    if (body.classList.contains('navbar--show-search') && input) {
      window.setTimeout(() => input.focus(), 300);
    }
  });

  document.addEventListener('click', (e) => {
    if (
      e.target.closest(
        '.navbar__overlay, .search__close, .search__backdrop, .icon-search-close'
      )
    ) {
      closePopup();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && body.classList.contains('navbar--show-search')) {
      closePopup();
    }
  });
})();
